import React, { useState, useContext} from 'react'
import Icon from '@material-ui/core/Icon'
import { ThemeContext } from 'styled-components'
import { AuthContext } from '../../../../../auth-context'
import CameraIcon from '@material-ui/icons/CameraAlt'
import moment from 'moment'
import '../../../../../css/inspect.sass'
import iconCheck from '../../../../../images/iconCheck.png'
import iconOver from '../../../../../images/iconOver.png'
import iconDailyWeight from '../../../../../images/scale.svg'
import iconMeasurements from '../../../../../images/ruler.svg'
import iconNotes from '../../../../../images/notes.svg'
import iconPaused from '../../../../../images/new-vacation-mode/icon-small-pause.svg'
import iconPractice from "../../../../../images/new-vacation-mode/icon-small-practice.svg";

import { DarkTooltip } from './tooltip';
import { hostDateToString } from '../util'
import { PhotoModal } from './photo-modal'
import { DailyWeightModal } from './daily-weight-modal'
import { MeasurementModal } from './measurement-modal';
import { NotesModal } from './notes-modal';
import { CarryOverModal } from './carry-over-modal'
import ComplianceModal from './compliance-details'
import { getPortalAccountWeighInPhotos, getPortalSurveyResponse } from '../../../../../api'
import { SurveyModal } from '../../surveys/components/survey-modal'
import styled from 'styled-components'

const VacationText = styled.span`
  background: #06010d;
  border-radius: 30px;
  display: block;
  padding: 0px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  color: ${props => props.color || "#32F6DB"};
`;

const TimelineRow = (props) => {
  const [showFullText, updateShowFullText] = useState(false)
  const matchingWeighIn = props.user?.weighins?.find((weighin) => weighin.weight_id === props.record?.id) || null

  const isPaused = props.record.vacation_mode_info && !props.record.vacation_mode_info?.practice_mode
  const isPractice = props.record.vacation_mode_info && props.record.vacation_mode_info?.practice_mode

  const renderResetDash = (report_date) => {
    const resetHistory = props.user.resetHistory
    const recentStartingPoint = new Date(props.user.starting_point)
    const reportDate = new Date(report_date)

    if (resetHistory) {
      let toolString = 'Profile was reset';
      if (reportDate < recentStartingPoint) {
        resetHistory.forEach((range, index) => {
          const oldPoint = new Date(range.old_starting_point);
          const newPoint = new Date(range.new_starting_point);
          
          if (oldPoint <= reportDate && reportDate < newPoint) {
            const date = hostDateToString(range.new_starting_point)
            const dateFormatted = moment.utc(date).format('MMM D, YYYY')
            toolString = `Profile was reset on ${dateFormatted}`
          }
        })
      }

      return (
        <DarkTooltip
          title={<p>{toolString}</p>}
        >
          <p>-</p>
        </DarkTooltip>
      )
    } else {
      return (
        <DarkTooltip
          title={<p>Profile was reset</p>}
        >
          <p>-</p>
        </DarkTooltip>
      )
    }
  }

  const renderDash = () => {
    return (
      <DarkTooltip
        title={<p>User changed goal</p>}
      >
        <p>-</p>
      </DarkTooltip>
    )
  }

  const getRowColor = (record) => {
    const { check_in_type } = record

    let backgroundColor

    if(check_in_type === 1) {
      backgroundColor = '#fff0f0'
    } else if(check_in_type === 2) {
      backgroundColor = '#f0fff0'
    } else {
      backgroundColor = 'none'
    }
    return { background: backgroundColor }
  }

  const formatCameraColumn = (record) => {
    return record.photo_option === 3 && (
      <DarkTooltip title={<p>Check-in has progress photos</p>}>
        <CameraIcon style={{cursor: 'pointer'}} onClick={() => props.handleCameraClick(record)} />
      </DarkTooltip>
    )
  }

  const formatWeightColumn = (record) => {
    let result
    const date = moment.utc(record.report_date).format('MMM Do')

    if (!record.macros && record.settings_change !== 0) {
      result = renderResetDash(record.report_date)
    } else if (record.settings_change !== 0) {
      result = (
        <DarkTooltip
          title={<p>Weight N/A: {'\u00A0'}No new check-in occurred.</p>}
        >
          <p>-</p>
        </DarkTooltip>
      )
    } else if (record.estimated_weight === null) {
      result = (
        <>
          {(record.daily_weights.length !== 0) ?
            <DarkTooltip
              title={<p>Check-in has daily weights</p>}
            >
              <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <span onClick={() => props.handleDailyWeight({date: date, daily_weights: record.daily_weights})} style={{cursor: 'pointer'}}><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
                <p style={{fontWeight: 400}}>{Number(record.weight * 2.204622).toFixed(1)}</p>
              </div>
            </DarkTooltip>
            :
              <p style={{fontWeight: 400}}>{Number(record.weight * 2.204622).toFixed(1)}</p>
          }
        </>
      )
    } else {
      result = (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          {(record.daily_weights.length !== 0) &&
            <DarkTooltip
              title={<p>Check-in has daily weights</p>}
            >
              <div style={{display: 'flex', alignItems: 'center'}}>
                <span onClick={() => props.handleDailyWeight({date: date, daily_weights: record.daily_weights})} style={{cursor: 'pointer'}}><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
              </div>
            </DarkTooltip>
          }
          <DarkTooltip
            title={<p>{'Estimated weight (actual weight: ' + Number(record.weight * 2.204622).toFixed(1) + ' lbs)'}</p>}
          >
            <p style={{color: 'red'}}>{Number(record.estimated_weight * 2.204622).toFixed(1)}</p>
          </DarkTooltip>
        </div>
      )
    }
    return result
  }

  const formatBodyfatColumn = (record) => {
    const date = moment.utc(record.report_date).format('MMM Do')

    if (record.body_fat) {
      return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {Object.keys(record.measurements?.data || {}).length > 0 ?
            <DarkTooltip
              title={<p>Check-in has measurements</p>}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span onClick={() => props.handleMeasurement({date: date, data: record.measurements})} style={{cursor: 'pointer'}}><img src={iconMeasurements} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
                <p style={{fontWeight: 400}}>{record.body_fat + '%'}</p>
              </div>
            </DarkTooltip>
            :
            <p style={{fontWeight: 400}}>{record.body_fat + '%'}</p>
          }
        </div>
      )
    } else {
      if (!record.macros && record.settings_change !== 0) {
        return renderResetDash(record.report_date)
      } else {
        return (
          <DarkTooltip
            title={<p>Body fat N/A: {'\u00A0'}No new check-in occurred.</p>}
          >
            <p>-</p>
          </DarkTooltip>
        )
      }
    }
  }

  const formatRangeColumn = (record) => {
    const checkInType = props.checkInType
    if(record.check_in_type === 12 && isPaused) {
      return (
        <DarkTooltip
          title={<p>Goal was paused</p>}
        >
          <img src={iconPaused} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} alt="icon" style={{height: '24px', width: '24px', marginTop: '0px', marginLeft: '2px', cursor: 'pointer'}} />
        </DarkTooltip>
      )
    } else if(record.check_in_type === 12 && isPractice) {
      return (
        <DarkTooltip
          title={<p>Practice mode</p>}
        >
          <img src={iconPractice} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} alt="icon" style={{height: '24px', width: '24px', marginTop: '0px', marginLeft: '2px', cursor: 'pointer'}} />
        </DarkTooltip>
      )
    } else if(record.settings_change !== 0) {
      if (record.macros) {
        return (
          <DarkTooltip
            title={<p>Compliance N/A: {'\u00A0'}No new check-in occurred</p>}
          >
            <p>-</p>
          </DarkTooltip>
        )  
      } else {
        return renderResetDash(record.report_date)
      }
    } else {
      if (record.check_in_type <= 2) {
        return (
          <DarkTooltip
            title={<p>{record.compliant ? 'In range of macros' : 'Out of range of macros'}</p>}
          >
            <img className='timeline-table-compliant' src={record.compliant ? iconCheck : iconOver} alt={record.compliant ? 'in range' : 'out of range'} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} />
          </DarkTooltip>
        )
      } else {
        return checkInType
      }
    }
  }

  const showCarryIcon = (record) => {
    if(record.keep) {
      return (
        <>
          <DarkTooltip
            title={<p>User kept old macros</p>}
          >
            <Icon style={{ color: 'purple', fontSize: '16px', cursor: 'pointer'}} onClick={() => props.handleCarryOver(record)}>update</Icon>
          </DarkTooltip>
        </>
      )
    } else if(record.custom_calories !== null) {
      return (
        <>
          <DarkTooltip
            title={<p>Custom calories set</p>}
          >
            <Icon style={{ color: 'purple', fontSize: '16px'}}>edit</Icon>
          </DarkTooltip>
        </>
      )
    }
  }

  const formatReason = (goal, reason, reportDate, settingsChange, reason2, record) => {
    const rowDate = hostDateToString(reportDate)
    const startDateClicked = hostDateToString(props.user.start_button_start_date)
    const createdAccountDate = hostDateToString(props.user.created_at)
    const weighins = props.user.weighins
    let result

    const isPaused = record.vacation_mode_info && !record.vacation_mode_info?.practice_mode
    const isPractice = record.vacation_mode_info && record.vacation_mode_info?.practice_mode

    if(record.check_in_type === 5) {
      if(isPaused){
        result = <p>Exiting pause your goal</p>
      } else if(isPractice) {
        result = <p>Exiting practice mode</p>
      } else {
        result = <p>Exiting pause your goal {reason2}</p>
      }
    } else if (reason === 'Weekly body metrics') {
      if(isPaused){
        result = <p>Goal Paused:  Macro adjustments off</p>
      } else if(isPractice) {
        result = <p>Practice Mode:  Macro adjustments off</p>
      }
    } else if (reason === 'resuming via old macros') {
      if(isPaused){
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting pause your goal {reason2}</p></div>)
      } else if(isPractice) {
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting practice mode {reason2}</p></div>)
      } else {
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting pause your goal {reason2}</p></div>)
      }
      
    } else if (reason && reason.slice(-3) === ' :)') {
      if(isPaused){
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting pause your goal {reason2}</p></div>)
      } else if(isPractice) {
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting practice mode {reason2}</p></div>)
      } else {
        result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Exiting pause your goal {reason2}</p></div>)
      }
    } else if (( startDateClicked !== createdAccountDate) && (startDateClicked === rowDate) ) {
      result = (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Clicked start after 24hrs <Icon style={{ color: '#eb0029', marginLeft: '4px', verticalAlign: 'middle' }}>report</Icon>{reason2}</p></div>)
    } else if (reason === 'carrying over same macros') {
      let reason_code = 0
      let reason_text = ''

      weighins.forEach(function(weighin) {
        if(weighin.report_date.valueOf() === reportDate.valueOf()) {
          reason_code = weighin.reason_code
          reason_text = weighin.reason_text
        }
      })
      result = (<div style={{ cursor: 'pointer' }} onClick={() => handleText()}><p>Refused Adjustment: {limitStringLength(getReasonsDisplayForm(goal, reason_code, reason_text))}{reason2}</p></div>)
    } else {
      result = (<p>{reason}{reason2}</p>)
    }

    if (result) {
      return result
    } else {
      return '-'
    }
  }

  const getSurveyData = (record) => {
    if (!matchingWeighIn?.survey_response_id) {
      return
    }

    getPortalSurveyResponse(props.requesterId, props.user.id)
      .then((res) => {
        const matchingResponse = res?.data?.responses?.find(
          (response) => response.id === matchingWeighIn.survey_response_id
        )

        if (matchingResponse) {
          props.handleShowSurvey(matchingResponse)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const formatReason2 = (gender, record) => {
    let result = ''
    if (gender === 'FEMALE' && record.settings_change === 0 && record.menstrual_retaining && !record.near_period) {
      result += ' (Near period but normal adjustment allowed)'
    }
    return result
  }

  const getReasonsDisplayForm = (goal, reason_code, reason_text) => {
    const reasons = getAbbreviatedCarryOverReasons(goal)
    let list = ''

    reasons.forEach((reason) => {
      if(reason_code & reason[0]) {
        list += ', ' + reason[1]
      }
    })

    if(reason_code & 16) {
      list += ', Other: ' + reason_text
    }

    if(list) {
      return list.slice(2)
    } else {
      return 'No Reason Given'
    }
  }

  const limitStringLength = (input) => {
    let MAX_LENGTH = 100

    if(showFullText)
      MAX_LENGTH = 600

    return (input.length < MAX_LENGTH) ? input : input.substring(0, MAX_LENGTH) + '...'
  }

  const handleText = () => {
    updateShowFullText(!showFullText)
  }

  const getAbbreviatedCarryOverReasons = (goal) => {
    let reasons
    switch(goal) {
      case 'FAT LOSS':
        reasons = [
          [1, "Happy with WL"],
          [2, "Unusual Activity Level"],
          [4, "Adding More Exercise"],
          [8, "Retaining Water"],
          [16, "Reducing Exercise"]
        ]
        break
  
      case 'MUSCLE GAIN':
        reasons = [
          [1, "Happy with MG"],
          [2, "Unusual Activity Level"],
          [4, "Reducing Exercise"],
          [8, "Minimize Fat Gain"],
          [16, "Adding More Exercise"],
          [32, "Retaining Water"]
        ]
        break
  
      case 'REVERSE DIETING':
        reasons = [
          [1, "Allow Extra Adaptation"],
          [2, "Unusual Activity Level"],
          [4, "Reducing Exercise"],
          [8, "Slow Reverse"]
        ]
        break
  
      case 'MAINTENANCE':
        reasons = [
          [1, "Unusual Activity Level"],
          [2, "Adding More Exercise"],
          [4, "Retaining Water"],
          [8, "Increasing Range"],
          [16, "Reducing Exercise"],
          [32, "Reducing Range"]
        ]
        break

      default:
        reasons = []
    }
    return reasons
  }

  const createActions = (record) => {
    const date = moment.utc(record.report_date).format('MMM Do')
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '4px'}}>
        {record.coach_edited && 
          <DarkTooltip
            title={<p>Check-in was edited by a coach</p>}
          >
            <Icon style={{color: '#800080', paddingTop: '1px', margin: '0px 6px'}}>sports</Icon>
          </DarkTooltip>
        }
        {record.notes.length > 0 && 
          <DarkTooltip
            title={<p>Check-in has notes attached</p>}
          >
            <span onClick={() => props.handleNotes({ date: date, data: record.notes })} style={{cursor: 'pointer'}}>
              <img src={iconNotes} alt="icon" style={{height: '18px', width: '18px', marginTop: '3px', margin: '0px 6px'}} />
            </span>
          </DarkTooltip>
        }
      </div>  
    )
  }

  const reportDate = new Date(props.record.report_date)
  const recentStartingPoint = new Date(props.user.starting_point)

  if (!props.record.macros && reportDate < recentStartingPoint) {
    const resetHistory = props.user.resetHistory
    let resetString = 'Profile was reset';

    if (resetHistory) {
      if (reportDate < recentStartingPoint) {
        resetHistory.forEach((range, index) => {
          const oldPoint = new Date(range.old_starting_point);
          const newPoint = new Date(range.new_starting_point);
          
          if (oldPoint <= reportDate && reportDate < newPoint) {
            const date = hostDateToString(range.new_starting_point)
            const dateFormatted = moment.utc(date).format('MMM D, YYYY')
            resetString = `Profile was reset on ${dateFormatted}`
          }
        })
      }
    }


    if (props.record.settings_change === 0) {
      // Show check-ins before profile reset
      return (
        <div
          className="custom-table-row"
          style={getRowColor(props.record)}
          id="timeline-table-row"
        >
          <div className='date spacer-right'><p>{props.date}</p></div>
          <div className='camera'></div>
          <div className='survey'></div>
          <div className='weight spacer-left'>{formatWeightColumn(props.record)}</div>
          <div className='bf'>{formatBodyfatColumn(props.record)}</div>
          {(props.user.gender === 'FEMALE') &&
            <div className='near-period'>
              {(props.record.settings_change !== 0) ? 
                <DarkTooltip
                  title={<p>Menstrual cycle N/A: {'\u00A0'}No new check-in occurred</p>}
                >
                  <p>-</p>
                </DarkTooltip>
              : 
                (props.record.menstrual_retaining === 1 || props.record.estimated_weight !== null) ? 
                  <DarkTooltip
                    title={<p>Period is affecting weight</p>}
                  >
                    <p>Yes</p>
                  </DarkTooltip>
                : 
                  <DarkTooltip
                    title={<p>Period is not affecting weight</p>}
                  >
                    <p>No</p>
                  </DarkTooltip>
              }
            </div>
          }
          <div className='measurement spacer-right'>
            {formatRangeColumn(props.record)}
          </div>

          <div className='goal spacer-left spacer-right'>
            {isPaused && <VacationText color="#32F6DB">Goal paused</VacationText>}
            {isPractice && <VacationText color="#CFE92A">Practice mode</VacationText>}
            <p>{props.goal}</p>
            <p>{props.goalLevel}</p>
          </div>

          <div className='protein spacer-left'><p style={{opacity: 0}}>-</p></div>
          <div className='carbs'><p style={{opacity: 0}}>-</p></div>
          <div className='fat'><p>{resetString}</p></div>
          <div className='calories spacer-right'><p style={{opacity: 0}}>-</p></div>
          {!props.recent && <div className='reason spacer-left'><p style={{opacity: 0}}>-</p></div>}
          <div className='actions spacer-left'>{(props.record.settings_change === 0) && createActions(props.record)}</div>
        </div>
      )
    } else {
      // Hide setting changes before profile reset
      return null
    }
  } else if (reportDate >= recentStartingPoint) {
    return (
      <div
        className="custom-table-row"
        style={getRowColor(props.record)}
        id="timeline-table-row"
      >
        <div className='date spacer-right'><p>{props.date}</p></div>
        {(props.record.settings_change !== 0) ?
          <>
            <div className='camera'></div>
            <div className='survey'></div>
            <div className='weight spacer-left'><p style={{opacity: 0}}>-</p></div>
            {/* <div className='weight spacer-left' style={{whiteSpace: 'prewrap'}}>
              <DarkTooltip
                title={<p>A setting, goal change, or edit was made that did not require a new check-in</p>}
              >
                <p className='setting-change'>No check-in</p>
              </DarkTooltip>
            </div> */}
            <div className='bf'>
              <DarkTooltip
                title={<p>A setting, goal change, or edit was made that did not require a new check-in</p>}
              >
                <p className='setting-change'>No check-in</p>
              </DarkTooltip>
            </div>
            {/* <div className='bf'><p style={{opacity: 0}}>-</p></div> */}
            {(props.user.gender === 'FEMALE') &&
              <div className='near-period'>
                <p style={{opacity: 0}}>-</p>
              </div>
            }
            <div className='measurement spacer-right'>
              <p style={{opacity: 0}}>-</p>
            </div>
          </>
          :
          <>
            <div className='camera'>{props.user.portal_user_info?.trainer_permission_photos === 1 && formatCameraColumn(props.record)}</div>
            <div className='survey'>
              {matchingWeighIn?.survey_response_id && 
                <Icon style={{ color: '#54d054', cursor: 'pointer'}} onClick={() => getSurveyData(props.record)}>assignment</Icon>
              }
            </div>
            <div className='weight spacer-left'>{formatWeightColumn(props.record)}</div>
            <div className='bf'>{formatBodyfatColumn(props.record)}</div>
            {(props.user.gender === 'FEMALE') &&
              <div className='near-period'>
                {(props.record.settings_change !== 0) ? 
                  <DarkTooltip
                    title={<p>Menstrual cycle N/A: {'\u00A0'}No new check-in occurred</p>}
                  >
                    <p>-</p>
                  </DarkTooltip>
                : 
                  (props.record.menstrual_retaining === 1 || props.record.estimated_weight !== null) ? 
                    <DarkTooltip
                      title={<p>Period is affecting weight</p>}
                    >
                      <p>Yes</p>
                    </DarkTooltip>
                  : 
                    <DarkTooltip
                      title={<p>Period is not affecting weight</p>}
                    >
                      <p>No</p>
                    </DarkTooltip>
                }
              </div>
            }
            <div className='measurement spacer-right'>
              {formatRangeColumn(props.record)}
            </div>
          </>
        }

        <div className='goal spacer-left spacer-right'>
          {isPaused && <VacationText color="#32F6DB">Goal paused</VacationText>}
          {isPractice && <VacationText color="#CFE92A">Practice mode</VacationText>}
          <p>{props.goal}</p>
          <p>{props.goalLevel}</p>
        </div>

        <div className='protein spacer-left'>{(props.record.macros) ? (<p>{Math.round(props.record.macros.protein)}</p>) : renderDash()}</div>
        <div className='carbs'>{(props.record.macros) ? (<p>{Math.round(props.record.macros.carbs)}</p>) : renderDash()}</div>
        <div className='fat'>{(props.record.macros) ? (<p>{Math.round(props.record.macros.fat)}</p>) : renderDash()}</div>
        <div className='calories spacer-right'>
          {(props.record.macros) ?
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              {showCarryIcon(props.record)}
              <p>{((Math.round(props.record.macros.protein) + Math.round(props.record.macros.carbs)) * 4 + Math.round(props.record.macros.fat) * 9)}</p>
            </div>
          :
            renderDash()
          }
        </div>
        {!props.recent && 
          <div className='reason spacer-left'>{(props.record.macros) ? formatReason(props.record.goal, props.record.macros.adjustment.reason, props.record.report_date, props.record.settings_change, formatReason2(props.user.gender, props.record), props.record) : renderDash(props.record.report_date)}</div>
        }
        <div className='actions spacer-left'>{(props.record.settings_change === 0) && createActions(props.record)}</div>
      </div>
    )
  }
};






















const TimelineTable = (props) => {
  const account = props.account
  const ascendingOrder = props.ascendingOrder
  const { user } = useContext(AuthContext)
  const theme = useContext(ThemeContext)
  const [photoData, setPhotoData] = useState({show: false, record: null, loading: false, photos: null})
  const [showDailyWeightModal, setShowDailyWeightModal] = useState(false)
  const [dailyWeightData, setDailyWeightData] = useState('')
  const [showMeasurementModal, setShowMeasurementModal] = useState(false)
  const [measurementData, setMeasurementData] = useState('')
  const [showNotesModal, setShowNotesModal] = useState(false)
  const [notesData, setNotesData] = useState('')
  const [showCarryOverModal, setShowCarryOverModal] = useState(false)
  const [carryOverData, setCarryOverData] = useState('')
  const [showComplianceModal, setShowComplianceModal] = useState(false)
  const [complianceDate, setComplianceDate] = useState('')
  const [showSurveyModal, setShowSurveyModal] = useState(false)
  const [surveyData, setSurveyData] = useState('')

  const handleCameraClick = (record) => {
    if (!photoData.loading) {
      if (photoData.record !== null && photoData.record.id === record.id) {
        setPhotoData({show: true, record: record, loading: false, photos: photoData.photos})
      } else {
        setPhotoData({show: true, record: record, loading: true, photos: null})
        getPortalAccountWeighInPhotos(user.id, props.accountId, record.id).then((res) => {
          setPhotoData({show: true, record: record, loading: false, photos: res.data.photos})
        })
      }
    }
  }

  const handlePhotoModalClose = () => {
    if (!photoData.loading) {
      setPhotoData({show: false, record: photoData.record, loading: false, photos: photoData.photos})
    }
  }

  const handleShowCompliance = (date) => {
    setShowComplianceModal(true);
    setComplianceDate(date)
  }

  const formatCheckInType = (record) => {
    const {last_vacation_mode_info} = record
    const isPaused = last_vacation_mode_info && !last_vacation_mode_info?.practice_mode
    const isPractice = last_vacation_mode_info && last_vacation_mode_info?.practice_mode

    let checkInType
    let tipTextMap = {
      1: "Out of range of macros",
      2: "Out of range of macros",
      3: 'Forced check-in: \u00A0New starting point',
      4: 'Starting point',
      5: `Forced check-in: \u00A0Turned off ${isPractice ? 'practice' : 'pause your goal'} mode, triggering collection of new starting weight and body fat.`,
      6: "Forced check-in: \u00A0Changed activity level, triggering collection of new starting weight and body fat.",
      7: "Forced check-in: \u00A0Changed goal or goal level, triggering collection of new starting weight and body fat.",
      8: "Forced check-in: \u00A0Calories edited, triggering collection of new starting weight and body fat.",
      9: "Forced check-in: \u00A0Editing a check-in changed calories, triggering collection of new starting weight and body fat.",
      10: "Forced check-in: \u00A0Reset profile, triggering collection of new starting weight and body fat.",
      11: "Forced check-in: \u00A0Reset profile, triggering collection of new starting weight and body fat.",
    }

    switch (record.check_in_type) {
      case 1:
        checkInType = 'No'
        break

      case 2:
        checkInType = 'Yes'
        break

      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        checkInType = 'Forced'
        break

      case 4:
        checkInType = 'Start'
        break

      case 10:
      case 11:
        checkInType = 'Reset'
        break

      default:
        checkInType = ''
    }
    
    
    return (
      <DarkTooltip
        title={<p>{tipTextMap[record.check_in_type]}</p>}
      >
        <p>{checkInType}</p>
      </DarkTooltip>
    )
  }

  const getGoalLevel = (record) => {
    const LBS_PER_KG = 2.204622
    const goal = record.goal
    const targetWeight = record.target_weight
    const goal_weight_delta = record.goal_weight_delta
    const goal_min_weekly_calorie_increase = record.goal_min_weekly_calorie_increase

    if(!goal) // NOTE: Required when getUserFetch is not completed
      return

    if(goal === 'MAINTENANCE') {
      return ((targetWeight - goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' - ' + ((targetWeight + goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' lbs'
    } else if(goal === 'REVERSE DIETING') {
      return goal_min_weekly_calorie_increase + ' - ' + (goal_min_weekly_calorie_increase + 15) + ' kCal/wk'
    } else {
      return (goal_weight_delta * LBS_PER_KG).toFixed(2) + ' lbs/wk'
    }
  }

  let renderTimeline = account.timeline ? account.timeline : {}

  if(ascendingOrder) {
    renderTimeline = [...renderTimeline].reverse()
  }

  if(props.recent) {
    let recentCheckins = []
    renderTimeline.forEach((item) => {
      if(item.check_in_type) {
        recentCheckins.push(item)
      }
    });
    renderTimeline = recentCheckins

    // Last 6 check-ins
    renderTimeline = renderTimeline.slice(0, 6)
  }

  let relatedWeighInDateString = null
  if(complianceDate && account.user.starting_point && complianceDate >= account.user.starting_point.slice(0, 10)) {
    for(let key in props.macroData.weighInDetails) {
      if(key < complianceDate && (relatedWeighInDateString === null || key > relatedWeighInDateString)) {
        relatedWeighInDateString = key
      }
    }
  }

  return (
    <>
      <div className={props.recent ? 'custom-table recent' : 'custom-table'} id='custom-table-override'>
        <div className='custom-table-header-scroll' id='timeline-table-header'>
          <div className='date spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the date of this event.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Date</p>
            </DarkTooltip>
          </div>
          <div className='camera'></div>
          <div className='survey'></div>
          <div className='weight spacer-left'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This displays weight at each date.</p>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view daily weights</p>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>Weight<br/> (lbs)</p>
            </DarkTooltip>
          </div>
          <div className='bf'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This displays body fat percentage at each date.</p>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconMeasurements} alt="icon" style={{height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view measurements</p>
                </>
              }

            >
              <p style={{fontWeight: 'bold'}}>BF%</p>
            </DarkTooltip>
          </div>
          {account.user.gender === 'FEMALE' &&
            <div className='near-period spacer-right'>
              <DarkTooltip
                placement="top"
                title={<p>This shows whether a user’s menstrual cycle was affecting their weight.</p>}
              >
                <p style={{fontWeight: 'bold'}}>Near Period</p>
              </DarkTooltip>
            </div>
          }
          <div className='measurement spacer-right'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This shows where the client is at in their current check-in period:</p>
                  <div style={{height: '8px'}}></div>
                  <li><span><img className='timeline-table-compliant' src={iconCheck} alt="icon" style={{height: '16px', width: '16px'}} /></span> In range of macros</li>
                  <li><span><img className='timeline-table-compliant' src={iconOver} alt="icon" style={{height: '16px', width: '16px'}} /></span> Out of range of macros</li>
                  <li>Forced check-in (User changed a setting that required a new starting weight)</li>
                  <div style={{height: '16px'}}></div>
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <img className='timeline-table-compliant' src={iconCheck} alt="icon" style={{height: '16px', width: '16px', marginRight: '4px'}} />
                    <img className='timeline-table-compliant' src={iconOver} alt="icon" style={{height: '16px', width: '16px', marginRight: '4px'}} />
                    <p style={{fontStyle: 'italic'}}>* Tap these icons to view the average tracked macros for this check-in.</p>
                  </div>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>In <br/> range</p>
            </DarkTooltip>
          </div>

          <div className='goal spacer-left spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the goal for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Goal</p>
            </DarkTooltip>
          </div>
          <div className='protein spacer-left'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the protein target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Protein</p>
            </DarkTooltip>
          </div>
          <div className='carbs'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the carbs target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Carbs</p>
            </DarkTooltip>
          </div>
          <div className='fat'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the fat target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Fat</p>
            </DarkTooltip>
          </div>
          <div className='calories spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the calorie target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>kCal</p>
            </DarkTooltip>
          </div>

          {!props.recent && 
            <div className='reason spacer-left'>
              <DarkTooltip
                placement="top"
                title={<p>This describes what happened at each date below, including calorie adjustments associated with a check-in or any changes to settings.</p>}
              >
                <p style={{fontWeight: 'bold'}}>Reason</p>
              </DarkTooltip>
            </div>
          }
          <div className='actions spacer-left'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This shows the available actions for this date:</p>
                  <div style={{height: '8px'}}></div>
                  <p><Icon style={{color: '#800080', paddingTop: '1px', marginRight: '8px', fontSize: '1.125rem'}}>sports</Icon> Check-in was edited by a coach</p>
                  <div style={{height: '16px'}}></div>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconNotes} alt="icon" style={{ height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view notes</p>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>Actions</p>
            </DarkTooltip>
          </div>
        </div>
        {renderTimeline.map((record, index) => {
          const date = (moment.utc(record.report_date).format('MMM D, YYYY'));
          const checkInType = formatCheckInType(record)

          return (
            <TimelineRow
              key={index}
              date={date}
              weight={record.weight}
              estimated_weight={record.estimated_weight}
              bodyFat={(record.body_fat) ? record.body_fat + '%' : '-'}
              compliant={record.compliant}
              settings_change={record.settings_change}
              check_in_type={record.check_in_type}
              checkInType={checkInType}
              goal={theme.goal[record.goal]}
              goalLevel={getGoalLevel(record)}
              // calories={<div className="vertical-container">{(record.macros) ? showCarryIcon(record) : '-'} <p>{(record.macros) ? ((Math.round(record.macros.protein) + Math.round(record.macros.carbs)) * 4 + Math.round(record.macros.fat) * 9) : '-'}</p></div>}
              // protein={(record.macros) ? Math.round(record.macros.protein) : '-'}
              // carbs={(record.macros) ? Math.round(record.macros.carbs) : '-'}
              // fat={(record.macros) ? Math.round(record.macros.fat) : '-'}
              nearPeriod={(account.user.gender === 'FEMALE') ? ((record.settings_change !== 0) ? '-' : ((record.near_period === 1 || record.estimated_weight !== null) ? 'Yes' : 'No')) : ''}
              recent={props.recent}
              record={record}
              user={account.user}
              requesterId={user.id}
              handleCameraClick={handleCameraClick}
              handleDailyWeight={(data) => {setShowDailyWeightModal(true); setDailyWeightData(data)}}
              handleMeasurement={(data) => {setShowMeasurementModal(true); setMeasurementData(data)}}
              handleNotes={(data) => {setShowNotesModal(true); setNotesData(data)}}
              handleCarryOver={(data) => {setShowCarryOverModal(true); setCarryOverData(data)}}
              handleShowCompliance={(date) => {handleShowCompliance(date)}}
              handleShowSurvey={(data) => {setShowSurveyModal(true); setSurveyData(data);}}
            />
            )
        })}
      </div>

      <PhotoModal
        open={photoData.show}
        onClose={handlePhotoModalClose}
        record={photoData.record}
        loading={photoData.loading}
        photos={photoData.photos}
        accountId={props.accountId}
        account={account}
      />

      <DailyWeightModal
        open={showDailyWeightModal}
        onClose={() => setShowDailyWeightModal(false)}
        data={dailyWeightData}
      />

      <MeasurementModal
        open={showMeasurementModal}
        onClose={() => setShowMeasurementModal(false)}
        data={measurementData}
      />

      <NotesModal
        open={showNotesModal}
        onClose={() => setShowNotesModal(false)}
        data={notesData}
      />

      <CarryOverModal
        open={showCarryOverModal}
        onClose={() => setShowCarryOverModal(false)}
        data={carryOverData}
      />

      <ComplianceModal
        open={showComplianceModal}
        handleClose={() => setShowComplianceModal(false)}
        complianceDetailsDate={complianceDate}
        relatedWeighInDateString={relatedWeighInDateString}
        relatedWeighInDetails={props.macroData.weighInDetails[relatedWeighInDateString] || null}
        getMacroData={props.getMacroData}
        vacationMode={account.user.vacation_mode}
      />

      <SurveyModal
        open={showSurveyModal}
        onClose={() => setShowSurveyModal(false)}
        data={surveyData}
        // clientUserID={account.user.vacation_mode}
      />
    </>
  )
}

export default TimelineTable
